import * as _ from 'underscore';

let DomSorter = function () {
    let config = {};

    let initialize = function (el) {
            this.$el = $(el);
            this.$el.find('a.sort').on('click', sortDom);

            let dataConfigString = this.$el.data('config'),
                configArr;

            configArr = dataConfigString.split(';');

            // Build the configuration for the plugin out of the data-config attr.
            _.each(configArr, function (configPair) {
                var configPairArr = configPair.split(':');
                config[configPairArr[0]] = configPairArr[1];
            });
        },
        sortDom = function (e) {
            e.preventDefault();
            e.stopImmediatePropagation();
            $(this).domSorter(config);
        }

    // Expose the public API.
    return {
        init: initialize
    };
};

export default function (el) {
    let domSorter = new DomSorter();
    domSorter.init(el);

    return domSorter;
};
